import { carouselData } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
            焦点推荐
          </h2>
          <p className="text-sm text-foreground-500">精选热门漫画，每一部都值得从头追到尾</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {carouselData.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300/60 transition-all cursor-pointer"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-56 object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-3 py-1 bg-accent-500 text-background-50 text-xs font-semibold rounded-full">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">{item.desc}</p>
                <div className="flex items-center gap-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line"></i>
                    {item.readers} 阅读
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-file-list-3-line"></i>
                    {item.chapters}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}